import { useAuth } from 'hooks/auth';
import React from 'react';
import { i18n } from 'translate/i18n';

import './style.css'

function NotFound({ history }) {
const { signOut } = useAuth();

    return ( 
        <div className="not-found-container">
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column'}}>
                <h1 style={{fontSize: 60}}>404 ERROR</h1>
                <h3 style={{fontSize: 30}}>PAGE NOT FOUND</h3>
            </div>
            <button onClick={() => { signOut(); history.push('/login');}} style={{borderWidth: 1, borderColor: 'rgba(0,0,0,0.2)'}} className="back-to-dashboard">{i18n.t('backToLogin')}</button>
        </div>
    );
}

export default NotFound;